import { render } from "./news.vue?vue&type=template&id=904a6f7c&scoped=true"
import script from "./news.vue?vue&type=script&lang=js"
export * from "./news.vue?vue&type=script&lang=js"

import "./news.vue?vue&type=style&index=0&id=904a6f7c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-904a6f7c"

export default script